// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import mainSlider from './js/widgets/mainSlider.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import cardWidget10 from './js/widgets/cardsWidget.js';
import hotButtonsWidget from './js/widgets/hotButtonsWidget.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
  if (globalThis.location.pathname === '/') {
    mainSlider();
    eventsWidget();
    cardWidget10('cardWidget10First', cardWidget10FirstOpts, 2);
    cardWidget10('cardWidget10Second', cardWidget10SecondOpts, 4);
    hotButtonsWidget();
    sponsors();
  }
});
